import { createTheme } from "@mui/material/styles";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import { LinkProps } from "@mui/material/Link";
import { forwardRef } from "react";

// eslint-disable-next-line react-refresh/only-export-components
const LinkBehavior = forwardRef<
  HTMLAnchorElement,
  Omit<RouterLinkProps, "to"> & { href: RouterLinkProps["to"] }
>((props, ref) => {
  const { href, ...other } = props;
  // Map href (Material UI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
});

export const customThemeProps = {
  cssVariables: true,
  components: {
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
        },
      },
    },
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      } as LinkProps,
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
  },
  palette: {
    primary: {
      main: "#d52273",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#26224f",
    },
    error: {
      main: "#d52a22",
    },
    warning: {
      main: "#cdd522",
    },
    success: {
      main: "#73d522",
    },
    background: {
      default: "#FAFAFA",
    },
  },
  typography: {
    allVariants: {
      fontFamily: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
    },
    body1: {
      fontSize: "0.75rem",
    },
  },
};

// A custom theme for this app
const theme = createTheme(customThemeProps);

export default theme;
